<div class="reseller-map-container">
  <div class="form-group">
    <div class="search-data">
      <input
        [formControl]="searchResellerFormControl"
        class="ntfc-input-100"
        id="resellerSearch"
        type="text"
        [placeholder]="
          mapType === mapTypeEnum.ALL ? 'Itt kereshetsz boltra, partnerre vagy városra!' : 'Itt kereshetsz'
        "
      />
      <button class="new-netfone-button secondary black" (click)="navigateToCurrentPosition()">
        Ráközelítés tartózkodási helyemre
      </button>
    </div>
  </div>

  <div class="search-checkbox-container" *ngIf="mapType === mapTypeEnum.ALL">
    <ose-checkbox
      [ngModel]="searchForVeaShop"
      (click)="changeVeaShopSearchCb($event)"
      [ngModelOptions]="{ standalone: true }"
      >Netfone boltok</ose-checkbox
    >
    <ose-checkbox [ngModel]="searchForUser" (click)="changeUserSearchCb($event)" [ngModelOptions]="{ standalone: true }"
      >Netfone képviselők</ose-checkbox
    >
  </div>
  <div class="reseller-result-container">
    <div class="reseller-result" [class]="{ 'reseller-result-container-few-data': fewData() }">
      <div class="reseller-map-card-container cursor-pointer" (click)="zoomInOnMarker(netfoneOfficeMarker)">
        <div class="netfone-card-container">
          <img class="netfone-card-image" [src]="netfoneOffice.image" [alt]="netfoneOffice.name" />
          <div class="netfone-card-data">
            <span class="name">{{ netfoneOffice.name }}</span>
            <span class="clickable-data">{{ netfoneOffice.address }}</span>
            <span class="clickable-data">{{ netfoneOffice.address2 }}</span>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!(loadingSubject$ | async); else loading">
        <perfect-scrollbar>
          <div class="reseller-map-card-container cursor-pointer" *ngFor="let shop of filteredVeaShop">
            <ose-reseller-shop-card
              [data]="shop"
              class="cursor-pointer"
              (click)="zoomInOnMarker(shop.marker)"
            ></ose-reseller-shop-card>
          </div>
          <div class="reseller-map-card-container cursor-pointer" *ngFor="let user of filteredUsers">
            <ose-reseller-user-card [data]="user" (click)="zoomInOnMarker(user.marker)"></ose-reseller-user-card>
          </div>
        </perfect-scrollbar>
      </ng-container>
    </div>
    <div class="reseller-map">
      <google-map
        *ngIf="googleMapsAPILoaded"
        [width]="null"
        [height]="null"
        [zoom]="zoom"
        [center]="center"
        [options]="options"
        #map
        class="ntfc-reseller-gmaps"
      >
        <map-marker
          *ngFor="let marker of markers"
          [position]="marker.position"
          [title]="marker.title"
          [options]="marker.options"
          (mapClick)="mapMarkerClick(marker)"
        >
        </map-marker>
      </google-map>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="d-flex justify-content-center loader-centered-mobile">
    <app-loading></app-loading>
  </div>
</ng-template>
